import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import { useSubmitField } from '../../hooks/useSubmitField';
import { isWatchersOnly } from '../../utils/galleries';
import {
  anySelected,
  deselectItemsMatching,
  updateItemSelection,
} from '../../utils/select';
import { initAdapter, submitAdapter } from './adapters';
import { validator } from './validation';

export const useTierSelectField = () => {
  const { getValues, setValue } = useFormContext();
  const {
    id,
    error,
    field: { value, onChange },
    ref,
  } = useSubmitField('tiers', {
    initAdapter,
    submitAdapter,
    validator,
  });

  const handleChange = useCallback(
    (isSelected, itemId) => {
      // Deselect watchers-only galleries
      const values = getValues();
      if (
        anySelected(values['galleries'], ({ gallery }) =>
          isWatchersOnly(gallery)
        )
      ) {
        const deselectedGalleries = deselectItemsMatching(
          values['galleries'],
          ({ gallery }) => isWatchersOnly(gallery)
        );
        setValue('galleries', deselectedGalleries, { shouldDirty: true });
      }

      const newValue = updateItemSelection(value, itemId, isSelected);
      onChange(newValue);
    },
    [value, onChange, getValues, setValue]
  );

  return {
    id,
    error,
    items: value,
    onChange: handleChange,
    ref,
  };
};
